import * as React from 'react';
import type { ProgressRingProps } from './ProgressRing.types';

// TODO: This is going to be used in SearchResultsList.js which is ugly as f.
// This component can be improved by further decoupling the data
// from the "view" but time constraints!
const ProgressRing = ({
  radius,
  strokeColor,
  strokeWidth,
  progress,
  className,
}: ProgressRingProps): React.ReactElement<any> => {
  const normalizedRadius = radius - strokeWidth * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (progress / 100) * circumference;
  return (
    <svg className={className} height={radius * 2} width={radius * 2}>
      <circle
        stroke={strokeColor}
        fill='transparent'
        strokeWidth={strokeWidth}
        strokeDasharray={`${circumference} ${circumference}`}
        style={{
          strokeDashoffset,
          transform: 'rotate(-90deg)',
          transformOrigin: '50% 50%',
        }}
        r={normalizedRadius}
        cx={radius}
        cy={radius}
      />
    </svg>
  );
};

export default ProgressRing;
